export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const pfx = opts.pfx;

  const { toolbarBtnPreBuiltSectionCode, refs, commands, label } = opts;

  let timedInterval;
  domc.addType('script', {
    view: {
      onRender() {
        const isCC = this.model.closestType(refs.preBuiltSectionRef);
        isCC && (this.el.innerHTML = '');
      },
    },
  });

  domc.addType(refs.preBuiltSectionRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: label,
          editable: true,
          projectId: opts.projectId,
          ...opts.propsPreBuiltSectionCode,
        },

        init() {
          this.listenTo(
            this,
            `change:${refs.keyMarketPlaceCustomCode}`,
            this.onPreBuiltSectionCodeChange,
          );
          const initialCode = this.get(refs.keyMarketPlaceCustomCode) || opts.placeholderContent;

          !this.components().length && this.components(initialCode);
          const toolbar = this.get('toolbar');
          const id = 'pre-built-section';

          // Add the custom code toolbar button if requested and it's not already in
          if (toolbarBtnPreBuiltSectionCode && !toolbar.filter((tlb) => tlb.id === id).length) {
            toolbar.unshift({
              id,
              command: commands.pre_built_section_custom_code,
              attributes: { class: 'fa fa-diamond', title: 'Select Pre-Built Layout' },
              ...toolbarBtnPreBuiltSectionCode,
            });
          }
        },

        onPreBuiltSectionCodeChange() {
          this.components(this.get(refs.keyMarketPlaceCustomCode));
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === refs.preBuiltSectionRef) {
            return {
              type: refs.preBuiltSectionRef,
            };
          }
        },
      },
    ),

    view: defaultType.view.extend({
      init() {
        this.listenTo(this.model.components(), 'add remove reset', this.onComponentsChange);
        this.onComponentsChange();
      },

      onComponentsChange() {
        timedInterval && clearInterval(timedInterval);
        timedInterval = setTimeout(() => {
          const { model } = this;
          const content = model.get(refs.keyMarketPlaceCustomCode) || '';
          let droppable = 1;

          if (content.indexOf('<script') >= 0) {
            this.el.innerHTML = opts.placeholderScript;
            droppable = 0;
          }

          model.set({ droppable });
        }, 0);
      },

      onActive() {
        const target = this.model;
        this.em.get('Commands').run(commands.pre_built_section_custom_code, { target });
      },
    }),
  });
}
